import { CurrentBreakpoint } from 'hooks/useGetCurrentBreakpoint/useGetCurrentBreakpoint';

export enum SamplesTableSizes {
    xs,
    sm,
    md,
    lg,
    xl,
}

const withSidebarClosed: { [key: string]: SamplesTableSizes } = {
    xs: SamplesTableSizes.sm,
    sm: SamplesTableSizes.sm,
    ms: SamplesTableSizes.sm,
    md: SamplesTableSizes.md,
    ml: SamplesTableSizes.md,
    lg: SamplesTableSizes.lg,
    xl: SamplesTableSizes.lg,
    xxl: SamplesTableSizes.xl,
    jb: SamplesTableSizes.xl,
    default: SamplesTableSizes.xl,
    unknown: SamplesTableSizes.xl,
};

const withSidebarOpen: { [key: string]: SamplesTableSizes } = {
    xs: SamplesTableSizes.sm,
    sm: SamplesTableSizes.sm,
    ms: SamplesTableSizes.sm,
    md: SamplesTableSizes.md,
    ml: SamplesTableSizes.md,
    lg: SamplesTableSizes.md,
    xl: SamplesTableSizes.md,
    xxl: SamplesTableSizes.lg,
    jb: SamplesTableSizes.lg,
    default: SamplesTableSizes.lg,
    unknown: SamplesTableSizes.lg,
};

export const getSamplesTableSizes = ({
    currentBreakpoint,
    isSidebarOpen = false,
}: {
    currentBreakpoint: CurrentBreakpoint;
    isSidebarOpen?: boolean;
}) => {
    const currentSize: SamplesTableSizes = isSidebarOpen
        ? withSidebarOpen[currentBreakpoint]
        : withSidebarClosed[currentBreakpoint];

    const isSm = currentSize <= SamplesTableSizes.sm;
    const isMd = currentSize <= SamplesTableSizes.md;
    const isLg = currentSize <= SamplesTableSizes.lg;
    const isXl = currentSize <= SamplesTableSizes.xl;

    return { isSm, isMd, isLg, isXl };
};
